import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const partnersSchema = [
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
    { name: 'Partners', href: '/partners' },
  ]),
  {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Partner With Fore Capital',
  url: `${SITE_URL}/partners`,
  description: 'Partner with Fore Capital. Join our network of technology partners, referral partners, and integration partners building transparent payment infrastructure.',
  },
];

export default function Partners() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="Partner With Fore Capital | Grow Together"
        description="Partner with Fore Capital. Join our network of technology partners, referral partners, and integration partners building transparent payment infrastructure."
        keywords="Fore Capital partners, payment partnerships, integration partners, referral partners"
        pathname="/partners"
        schema={partnersSchema}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="bg-[#122852] py-20 px-5 md:px-[75px]">
          <div className="max-w-[1400px] mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 mb-6" aria-label="Breadcrumb">
              <a
                href="/"
                className="text-white/40 text-[11px] uppercase tracking-[0.18em] hover:text-white/70 transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Home
              </a>
              <span className="text-white/25 text-[11px]">/</span>
              <span
                className="text-[#d3b366] text-[11px] uppercase tracking-[0.18em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Partners
              </span>
            </nav>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.25em] font-medium mb-4"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Partners
            </p>
            <h1
              className="text-white text-3xl md:text-4xl lg:text-[48px] font-light leading-[1.1]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Grow Together.
              <br />
              <em className="not-italic text-[#d3b366]">Not Alongside.</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-28 px-5 md:px-[75px]">
          <div className="max-w-[900px] mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-[#061e45]/5 rounded-full mx-auto mb-8">
              <i className="ri-team-line text-[#125694] text-2xl" />
            </div>
            <h2
              className="text-[#061e45] text-2xl md:text-3xl font-light mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Partner With Fore Capital
            </h2>
            <p
              className="text-[#1A1A1A]/60 text-[15px] leading-relaxed max-w-xl mx-auto mb-10"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              We are building a network of technology partners, referral partners, and integration partners who share our commitment to transparent, operator-first payment infrastructure.
            </p>
            <p
              className="text-[#1A1A1A]/40 text-[15px]"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              This page is coming soon. For partnership inquiries, please contact us at{' '}
              <a href="mailto:partners@forecapital.io" className="text-[#a8894a] hover:underline cursor-pointer">
                partners@forecapital.io
              </a>
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}